import { render, staticRenderFns } from "./b-switch.vue?vue&type=template&id=766302f6&"
import script from "./b-switch.vue?vue&type=script&lang=ts&"
export * from "./b-switch.vue?vue&type=script&lang=ts&"
import style0 from "./b-switch.vue?vue&type=style&index=0&id=766302f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports